import KunLoading95 from './src/index'

KunLoading95.install = function (Vue) {
	Vue.component(KunLoading95.name, KunLoading95);
}

export default KunLoading95;
